'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _FacebookIcon = _interopRequireDefault(require("Icons/FacebookIcon"));
var _YoutubeIcon = _interopRequireDefault(require("Icons/YoutubeIcon"));
var _LinkedinIcon = _interopRequireDefault(require("Icons/LinkedinIcon"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
class Footer extends _react.Component {
  render = () => {
    let output = /*#__PURE__*/_react.default.createElement("footer", {
      className: "c-footer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-footer_column"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/",
      className: "o-front-header__logo-link"
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      className: "o-front-header__logo"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-footer_column"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "c-footer_ul"
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/",
      className: "c-footer-link c-circle-decoration c-circle-decoration--blue"
    }, "L'association")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/candidat",
      className: "c-footer-link c-circle-decoration c-circle-decoration--blue"
    }, "Candidats")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recruteurs",
      className: "c-footer-link c-circle-decoration c-circle-decoration--blue"
    }, "Recruteurs")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-footer_column"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "c-footer_ul"
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/pdf/CGU.pdf",
      className: "c-footer-link c-circle-decoration c-circle-decoration--blue",
      target: "_blank"
    }, "Conditions g\xE9n\xE9rales d'utilisation")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/mentions-legales",
      className: "c-footer-link c-circle-decoration c-circle-decoration--blue"
    }, "Mentions l\xE9gales")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/pdf/CGU.pdf",
      target: "_blank",
      className: "c-footer-link c-circle-decoration c-circle-decoration--blue"
    }, "Politique de confidentialit\xE9")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-footer_social"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "c-footer-link u-text-center u-full-width"
    }, "Suivez-nous"), /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.facebook.com/Aspiejob",
      className: "c-footer-social-link",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(_FacebookIcon.default, null)), /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.linkedin.com/company/aspiejob",
      className: "c-footer-social-link",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(_LinkedinIcon.default, null)), /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.youtube.com/channel/UCC_AlgZz1p5xa3DJ0CN95BA/featured",
      className: "c-footer-social-link",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(_YoutubeIcon.default, null)), /*#__PURE__*/_react.default.createElement("a", {
      href: "mailto:contact@aspiejob.org",
      className: "c-footer-social-link u-full-width c-footer-link u-text-center"
    }, "contact@aspiejob.org")));
    return output;
  };
}
exports.default = Footer;
